import { render, staticRenderFns } from "./EntityActions.vue?vue&type=template&id=24a92189&"
import script from "./EntityActions.vue?vue&type=script&lang=js&"
export * from "./EntityActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports